import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTruck, faCamera } from "@fortawesome/free-solid-svg-icons";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import placeholder from "../Icons/empty-placeholder.jpg";
import deliveryTruck from "../Icons/delivery-truck.png";
import "./OrderComponents.css";
import { ButtonBlue } from "../../HouseStyle/Components/Buttons";
import middleware from "../../Api/Middleware";
import { formatCurrency } from "../../../utils";
import ToastError from "../../Toasts/ToastError";

const VerwerkOrderComponent = ({
  productsToProcess,
  order
}) => {
  const navigate = useNavigate();
  const [quantities, setQuantities] = useState(
    productsToProcess.reduce(
      (acc, product) => ({
        ...acc,
        [product.sold_product_id]: 0,
      }),
      {}
    )
  );
  const [invoiceNote, setInvoiceNote] = useState(order.note);
  const [reference, setReference] = useState(order.reference);
  const strip = (html) => {
    let doc = new DOMParser().parseFromString(html, "text/html");
    return doc.body.textContent || "";
  };

  const calculatePriceWithSale = (item) => {
    const basePrice = item.price_incl_tax || 0;
    const saleAmount = item.sale_amount || 0;
    const saleUnit = item.sale_unit || 0;
    
    let finalPrice;
    if (saleUnit === 0) {
      // Sale amount in euros 
      finalPrice = basePrice - saleAmount;
    } else if (saleUnit === 1) {
      // Sale amount in percentage
      finalPrice = basePrice * (1 - (saleAmount / 100));
    } else {
      finalPrice = basePrice;
    }
    
    finalPrice = Math.max(0, finalPrice);
    
    return formatCurrency(parseFloat(finalPrice));
  };

  if (!productsToProcess.length) {
    return (
      <div className="card mb-3 rounded-4 border-0">
        <div className="card-body text-center py-4">
          <FontAwesomeIcon
            icon={faTruck}
            style={{ color: "#009fe3" }}
            size="2x"
            className="mb-3"
          />
          <p className="mb-0">Geen producten meer te verwerken</p>
        </div>
      </div>
    );
  }

  return (
    <div className="whiteBox p-5 pt-4 pb-4 mb-4 align-center">
      <div className="header d-flex justify-content-start align-items-center pb-4 bottom-border-line">
        <div>
          <h5 className="mb-0 fw-bold BlockTitle">Nog te verwerken</h5>
        </div>
      </div>
      {productsToProcess.length > 0 ? (
        <ul className="list-group list-group-flush">
          {productsToProcess.map((item, index) => {
            const price = item.price_incl_tax;
            if (item.amount - item.items_processed - item.items_credited > 0) {
              return (
                <li
                  key={index}
                  className="verwerk-list-group-item bottom-border-line d-flex justify-content-between align-items-center gap-3 pb-2 pt-2"
                >
                  <div className="d-flex flex-row gap-3 flex-grow-1">
                    <div className="d-flex align-items-center">
                      {/* Product image */}
                      <img
                        src={
                          item.image?.path
                            ? middleware.defaults.imagesBaseURL +
                              item.image?.path
                            : placeholder
                        }
                        className="rounded-circle p-2 me-3 object-fit-cover"
                        height={100}
                        width={100}
                        alt="placeholder..."
                      />
                    </div>

                    {/* Product info */}
                    <div className="d-flex flex-column justify-content-center align-items-start">
                      <a
                        href={`/producten/bewerken/${item.head_product_id ? item.head_product_id : item.product_id}`}
                        target="_blank"
                        className="new-link-color"
                      >
                        {item.product_name}
                      </a>
                      {item.product_description && (
                        <p className="text-muted small mb-0">
                          {strip(item.product_description)?.length < 100
                            ? strip(item.product_description)
                            : (strip(item.product_description)?.slice(0, 100) ??
                                "") + "..."}
                        </p>
                      )}
                    </div>
                  </div>

                  {/* Product price info */}
                  <div className='d-flex align-items-center justify-content-end gap-3 gap-xxl-5 flex-grow-1'>
                    {(item.sale_amount && item.sale_amount > 0) ? (
                      <div className='d-flex flex-column'>
                        <span className='text-nowrap text-muted text-decoration-line-through text-secondary'>{formatCurrency(item.price_incl_tax)}</span>
                        <span>{calculatePriceWithSale(item)}</span>
                      </div>
                    ) : (
                      <span className='text-nowrap'>{formatCurrency(item.price_incl_tax)}</span>
                    )}
                    <span className='text-nowrap'>x{item.amount - item.items_credited - item.items_processed}</span>
                    <span className='fw-semibold'>{formatCurrency((((item.sale_unit === 0 ? price - item.sale_amount : price * (100 - item.sale_amount) / 100)) * (item.amount - item.items_processed - item.items_credited)))}</span>
                  </div>
                </li>
              )
            }
          })}
        </ul>
      ) : (
        <div className="text-center p-3">
          <div className="text-center" role="status">
            <h5>There are no product to process...</h5>
          </div>
        </div>
      )}

      <div className="d-flex justify-content-end mt-3 ">
        <div className="d-flex">
          <ButtonBlue text="Verwerken" onClickFunction={()=>navigate('/bestellingen/verwerken/'+order.order_number)}/>
       </div>
        
      </div>
    </div>
  );
};

export default React.memo(VerwerkOrderComponent);
